import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { formatCLP, formatDateTime, apiError } from "../../lib/format";
import { toast } from "sonner";
import { CheckCircle, XCircle, HandCoins, Lightning } from "@phosphor-icons/react";

export default function LoanRequests() {
  const [loans, setLoans] = useState([]);
  const [filter, setFilter] = useState("pendiente");

  const load = () => api.get("/loans", { params: { status: filter || undefined } }).then((r) => setLoans(r.data));
  useEffect(() => { load(); }, [filter]); // eslint-disable-line

  const decide = async (id, action) => {
    try {
      await api.post(`/loans/${id}/${action}`, { comment: "" });
      toast.success("Hecho");
      load();
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div className="space-y-8">
      <header>
        <div className="label-mono mb-2">Bandeja</div>
        <h1 className="font-display text-4xl font-black tracking-tighter">Solicitudes de crédito</h1>
      </header>

      <div className="flex gap-0 border border-hairline w-fit">
        {["pendiente", "aprobado", "rechazado", "desembolsado", "ofrecido", ""].map((f) => (
          <button
            key={f || "all"}
            onClick={() => setFilter(f)}
            data-testid={`filter-${f || "all"}`}
            className={`h-10 px-4 text-xs font-mono uppercase tracking-widest border-r border-hairline last:border-r-0 ${filter === f ? "bg-forest text-bg" : "bg-surface hover:bg-bg"}`}
          >
            {f || "Todos"}
          </button>
        ))}
      </div>

      <div className="bento">
        <table className="w-full text-sm" data-testid="loans-table">
          <thead>
            <tr className="label-mono border-b border-hairline">
              <th className="text-left px-6 py-3">Fecha</th>
              <th className="text-left px-6 py-3">Cliente</th>
              <th className="text-right px-6 py-3">Monto</th>
              <th className="text-left px-6 py-3">Cuotas</th>
              <th className="text-left px-6 py-3">Motivo</th>
              <th className="text-left px-6 py-3">Estado</th>
              <th className="text-right px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {loans.length === 0 && <tr><td colSpan="7" className="p-10 text-center text-inkMuted text-sm">Sin solicitudes.</td></tr>}
            {loans.map((l) => (
              <tr key={l.id} className="border-b border-hairline hover:bg-bg">
                <td className="px-6 py-3 font-mono text-xs">{formatDateTime(l.created_at)}</td>
                <td className="px-6 py-3">
                  <Link to={`/app/clientes/${l.user_id}`} className="font-semibold hover:text-forest">{l.client_name}</Link>
                  <div className="label-mono">{l.origin}</div>
                </td>
                <td className="px-6 py-3 text-right font-mono font-medium">{formatCLP(l.amount)}</td>
                <td className="px-6 py-3">{l.cuotas}</td>
                <td className="px-6 py-3 text-inkMuted">{l.purpose || "—"}</td>
                <td className="px-6 py-3 label-mono">{l.status}</td>
                <td className="px-6 py-3 text-right space-x-2">
                  {(l.status === "pendiente" || l.status === "ofrecido") && (
                    <>
                      <button onClick={() => decide(l.id, "approve")} className="h-9 px-3 bg-success text-bg text-xs inline-flex items-center gap-1" data-testid={`approve-${l.id}`}>
                        <CheckCircle size={12} weight="bold" /> Aprobar
                      </button>
                      <button onClick={() => decide(l.id, "reject")} className="h-9 px-3 border border-danger text-danger text-xs inline-flex items-center gap-1" data-testid={`reject-${l.id}`}>
                        <XCircle size={12} weight="bold" /> Rechazar
                      </button>
                    </>
                  )}
                  {l.status === "aprobado" && (
                    <button onClick={() => decide(l.id, "disburse")} className="h-9 px-3 bg-burnt text-bg text-xs inline-flex items-center gap-1" data-testid={`disburse-${l.id}`}>
                      <Lightning size={12} weight="bold" /> Desembolsar
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
